export const COMPANY_TYPES = [
  { value: 'LLC', label: 'LLC (Limited Liability Company)' },
  { value: 'Corporation', label: 'Corporation' },
  { value: 'S-Corporation', label: 'S Corporation' },
  { value: 'C-Corporation', label: 'C Corporation' },
  { value: 'Partnership', label: 'Partnership' },
  { value: 'LLP', label: 'LLP (Limited Liability Partnership)' },
  { value: 'Sole-Proprietorship', label: 'Sole Proprietorship' },
  { value: 'Non-Profit', label: 'Non-Profit Organization' },
];
